import { Controller } from "@hotwired/stimulus";

// Dispatches "drawer:open" on window so the drawer controller (at body level) can open.
// Usage: data-controller="drawer-trigger" data-action="click->drawer-trigger#fire"
export default class extends Controller {
  fire() {
    window.dispatchEvent(new CustomEvent("drawer:open"));
  }
}
